<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12">
        <div class="login-form-img">
          <img :src="newPasswordImg" alt="login form img" />
        </div>
      </div>

      <div class="col-lg-6 col-md-12 col-sm-12">
        <div class="login-form-inputs">
          <a
            class="back-btn"
            href="javascript:void(0)"
            @click.prevent="emitToParent()"
          >
            <img src="../../../Assets/Images/arrow-left.png" alt="arrow" />
            <span>{{ objOtp.backBtn }}</span>
          </a>
          <div class="login-form-logo">
            <img src="../../../Assets/Images/logo-login.png" alt="Eda logo" />
          </div>
          <h3 class="generic-description">{{ objOtp.newPasswordTitle }}</h3>
          <form v-on:submit.prevent="onSubmit" class="form-container">
            <div class="input-field">
              <input
                :type="showPassword ? 'text' : 'password'"
                :placeholder="objOtp.newPassword"
                v-model.trim="formData.NewPassword"
              />
              <p v-if="$v.formData.NewPassword.$dirty">
                <span
                  class="form-container__error-msg"
                  v-if="!$v.formData.NewPassword.required"
                  >{{ objOtp.formPasswordRequired }}</span
                >
                <span
                  class="form-container__error-msg"
                  v-if="!$v.formData.NewPassword.passwordValidation"
                  >{{ objOtp.formPasswordNotValid }}</span
                >
              </p>
              <a
                @click.prevent="togglePassword()"
                href="javascript:void(0)"
                class="show-hide-password"
              >
                <span class="visibility">
                  <svg
                    v-if="showPassword"
                    xmlns="http://www.w3.org/2000/svg"
                    width="27.925"
                    height="20.855"
                    viewBox="0 0 27.925 20.855"
                  >
                    <g id="Icon_feather-eye" transform="translate(-.5 -5)">
                      <path
                        id="Path_6588"
                        d="M1.5 15.427S6.214 6 14.463 6s12.963 9.427 12.963 9.427-4.714 9.427-12.963 9.427S1.5 15.427 1.5 15.427z"
                        class="icon-path"
                      />
                      <path
                        id="Path_6589"
                        d="M20.57 17.035a3.535 3.535 0 1 1-3.535-3.535 3.535 3.535 0 0 1 3.535 3.535z"
                        class="icon-path"
                        transform="translate(-2.573 -1.608)"
                      />
                    </g>
                  </svg>
                  <svg
                    v-if="!showPassword"
                    xmlns="http://www.w3.org/2000/svg"
                    width="28.046"
                    height="28.046"
                    viewBox="0 0 28.046 28.046"
                  >
                    <g
                      id="Icon_feather-eye-off"
                      transform="translate(-.086 -.086)"
                    >
                      <path
                        id="Path_6613"
                        d="M20.918 21.979a11.543 11.543 0 0 1-6.809 2.361C6.085 24.34 1.5 15.17 1.5 15.17a21.149 21.149 0 0 1 5.8-6.809m4.4-2.086A10.454 10.454 0 0 1 14.109 6c8.024 0 12.609 9.17 12.609 9.17a21.206 21.206 0 0 1-2.476 3.657m-7.7-1.227a3.439 3.439 0 1 1-4.86-4.86"
                        class="icon-path"
                        transform="translate(0 -1.061)"
                      />
                      <path
                        id="Path_6614"
                        d="M1.5 1.5l25.218 25.218"
                        class="icon-path"
                      />
                    </g>
                  </svg>
                </span>
              </a>
            </div>
            <div class="input-field">
              <input
                :type="showConfirmPassword ? 'text' : 'password'"
                :placeholder="objOtp.formRetypePassword"
                v-model.trim="$v.formData.ConfirmNewPassword.$model"
              />
              <p v-if="$v.formData.ConfirmNewPassword.$dirty">
                <span
                  class="form-container__error-msg"
                  v-if="!$v.formData.ConfirmNewPassword.required"
                  >{{ objOtp.formRetypePasswordRequired }}</span
                >
                <span
                  class="form-container__error-msg"
                  v-if="!$v.formData.ConfirmNewPassword.sameAsPassword"
                  >{{ objOtp.formRetypePasswordNotSame }}</span
                >
              </p>
              <a
                @click.prevent="toggleConfirmPassword()"
                href="javascript:void(0)"
                class="show-hide-password"
              >
                <span class="visibility">
                  <svg
                    v-if="showConfirmPassword"
                    xmlns="http://www.w3.org/2000/svg"
                    width="27.925"
                    height="20.855"
                    viewBox="0 0 27.925 20.855"
                  >
                    <g id="Icon_feather-eye" transform="translate(-.5 -5)">
                      <path
                        id="Path_6588"
                        d="M1.5 15.427S6.214 6 14.463 6s12.963 9.427 12.963 9.427-4.714 9.427-12.963 9.427S1.5 15.427 1.5 15.427z"
                        class="icon-path"
                      />
                      <path
                        id="Path_6589"
                        d="M20.57 17.035a3.535 3.535 0 1 1-3.535-3.535 3.535 3.535 0 0 1 3.535 3.535z"
                        class="icon-path"
                        transform="translate(-2.573 -1.608)"
                      />
                    </g>
                  </svg>
                  <svg
                    v-if="!showConfirmPassword"
                    xmlns="http://www.w3.org/2000/svg"
                    width="28.046"
                    height="28.046"
                    viewBox="0 0 28.046 28.046"
                  >
                    <g
                      id="Icon_feather-eye-off"
                      transform="translate(-.086 -.086)"
                    >
                      <path
                        id="Path_6613"
                        d="M20.918 21.979a11.543 11.543 0 0 1-6.809 2.361C6.085 24.34 1.5 15.17 1.5 15.17a21.149 21.149 0 0 1 5.8-6.809m4.4-2.086A10.454 10.454 0 0 1 14.109 6c8.024 0 12.609 9.17 12.609 9.17a21.206 21.206 0 0 1-2.476 3.657m-7.7-1.227a3.439 3.439 0 1 1-4.86-4.86"
                        class="icon-path"
                        transform="translate(0 -1.061)"
                      />
                      <path
                        id="Path_6614"
                        d="M1.5 1.5l25.218 25.218"
                        class="icon-path"
                      />
                    </g>
                  </svg>
                </span>
              </a>
            </div>
            <button type="submit" class="custom-btn">
              {{ objOtp.submit }}
            </button>
            <div class="news-letter__loader" v-if="isLoading">
              <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Vuelidate from "vuelidate";
import {
  required,
  helpers,
  requiredIf,
  sameAs,
} from "vuelidate/lib/validators";

import { headers, key } from '../../../Scripts/genericJSFile.js';

Vue.use(Vuelidate);

let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";

const passwordValidation = helpers.regex(
  "alpha",
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
);

export default {
  props: {
    signIn: {
      type: String,
    },
    objOtp: {
      type: Object,
    },
    backBtn: {
      type: String,
    },
    submit: {
      type: String,
    },
    forgetPasswordPageTitle: {
      type: String,
    },
    forgetPasswordEmailConfirmation: {
      type: String,
    },
  },
  data() {
    return {
      newPasswordImg: this.objOtp.imgDesktop,
      isSuccess: false,
      isLoading: false,
      showPassword: false,
      showConfirmPassword: false,
      formData: {
        NewPassword: "",
        ConfirmNewPassword: "",
      },
    };
  },
  validations: {
    formData: {
      NewPassword: {
        required,
        passwordValidation,
      },
      ConfirmNewPassword: {
        required: requiredIf(function() {
          return this.formData.NewPassword != "";
        }),
        sameAsPassword: sameAs("NewPassword"),
      },
    },
  },
  methods: {
    onSubmit() {
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        return;
      } else {
        this.isLoading = true;
        let headers = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        let formObj = {
          Email: this.objOtp.userEmail,
          Password: this.formData.NewPassword,
        };

        axios
          .post(
            `${apiUrl}/Umbraco/Surface/Users/ConfirmPassword`,
            formObj,
            headers
          )
          .then((res) => {
              this.isLoading = false;
            if (res.data === "true") {
                this.$emit('password', true);
                this.signOut();
            } else {
              this.emailNotValid = true;
              this.emailRequired = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      },
      signOut() {
          //let token = localStorage.getItem("token");
          //let headers = {
          //    headers: {
          //        'Authorization': `Bearer ${token}`
          //    },
          //};
          axios
              .post(`${apiUrl}/Umbraco/Surface/Users/signout`, key, headers)
              .then(() => {
                  localStorage.removeItem('token');
                  //sessionStorage.removeItem('token');
              })
              .catch((err) => {
                  console.log(err);
              });
      },
    emitToParent() {
        this.$emit("backBtn", true);
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
  },
  mounted() {
      if (window.innerWidth <= 768) {
          this.newPasswordImg = this.objOtp.imgMobile;
      } else {
          this.newPasswordImg = this.objOtp.imgDesktop;
      }
    if (document.querySelector(".navbar.navbar-expand-lg")) {
      document.querySelector(".navbar.navbar-expand-lg").style.display = "none";
      document.querySelector(".breadcrumb-container").style.display = "none";
      document.querySelector(".footer").style.display = "none";
      document.querySelector(".copy-right").style.display = "none";
    }
  },
};
</script>
